<main>
  <ag-announcements-banner></ag-announcements-banner>
  <div
    *ngIf="filterStaffList"
    fxLayout="row"
    fxLayoutAlign="space-between center"
    class="back-offset-two color-header-color"
  >
    <!-- mobile control panel -- START-->
    <!-- Search Dashboard -->
    <form *ngIf="searchText" [formGroup]="searchText" class="inline" fxFlex>
      <mat-form-field class="mat-form-field-only" fxFlex="auto" floatLabel="never">
        <button
          *ngIf="searchText?.controls['searchInput']?.value.length >= 1; else searchIcon"
          mat-icon-button
          matPrefix
          type="button"
          matTooltip="Clear Search"
          (click)="clearDash()"
        >
          <mat-icon>clear</mat-icon>
        </button>
        <ng-template #searchIcon>
          <button mat-icon-button matPrefix type="button">
            <mat-icon>search</mat-icon>
          </button>
        </ng-template>
        <input
          matInput
          agAutofocus
          formControlName="searchInput"
          autocomplete="off"
          title="Search Staff Dashboard"
          id="typeahead-staff"
          type="text"
          placeholder="Search Staff Dashboard"
        />
      </mat-form-field>
    </form>
    <!-- Toggle Menu -->
    <button
      mat-button
      role="button"
      aria-label="Add to Quick Menu"
      type="button"
      (click)="toggleAll()"
    >
      <mat-icon>{{ expandedAll ? 'close_fullscreen' : 'open_in_full' }}</mat-icon>
      Toggle Menu
    </button>
    <!-- END - mobile control panel -->
  </div>
  <div class="container-fluid">
    <div class="row">
      <div *ngIf="quickMenuList && filterStaffList" class="quickmenu-container d-none d-md-block">
        <mat-card>
          <mat-card-title>
            <div class="menu-header">Quick Links (Ctrl+)</div>
          </mat-card-title>
          <mat-card-content class="scroll">
            <ng-container *ngFor="let item of quickMenuList; let i = index">
              <a tabindex="0" [attr.title]="item.label" (agInteract)="quickmenuLink(item)">
                <!-- 61817 - Edge browser: VERSO Quick Links: First entry wrongly has vertical space below it -->
                <span class="quick-desc block-ellipsis pointer pull-left">{{
                  item.label | replaceUserGuidesStringsQuickLinks
                }}</span>
                <span
                  *ngIf="i < 9"
                  class="quick-hotkey badge badge-pill badge-default pull-right pointer"
                  >{{ i + 1 }}</span
                >
                <span
                  *ngIf="i === 9"
                  class="quick-hotkey badge badge-pill badge-default pull-right pointer"
                  >0</span
                >
              </a>
            </ng-container>
          </mat-card-content>
        </mat-card>
      </div>

      <div
        class="pm-select"
        [ngClass]="{ 'dash-board': !quickMenuList, 'dash-quick': quickMenuList }"
      >
        <ngx-masonry #masonry [options]="masonryKnights" [ordered]="true">
          <div
            *ngFor="let gMenus of filterStaffList; let i = index"
            ngxMasonryItem
            class="card-padding masonry-item"
          >
            <mat-card style="padding: 0px">
              <mat-card-title>
                <div tabindex="0" class="menu-header pointer" (agInteract)="toggleMenu(gMenus)">
                  {{ gMenus?.label }}
                  <i
                    class="fa menu-icon padding-5"
                    aria-hidden="true"
                    [id]="'icon' + i"
                    [ngClass]="gMenus.expanded ? 'fa-compress' : 'fa-expand'"
                  ></i>
                </div>
              </mat-card-title>
              <mat-card-content
                *ngIf="gMenus.expanded"
                class="scroll menu-content"
                [id]="'content' + i"
              >
                <ul *ngFor="let item of gMenus.items">
                  <li
                    *ngIf="!item.url?.includes('customer-care') || showCustomerCarePage"
                    class="main-items"
                    [ngClass]="item.url ? 'main-link' : 'no-link'"
                  >
                    <a
                      *ngIf="item.url; else noLink"
                      tabindex="0"
                      [rel]="gMenus.label + ' > ' + item.label"
                      [id]="'items_' + item.menuItem"
                      (agInteract)="itemClick(item)"
                    >
                      {{ item.label }}
                    </a>
                    <ng-template #noLink>
                      <span [id]="'items_' + item.menuItem">
                        {{ item.label }}
                      </span>
                    </ng-template>
                    <i
                      *ngIf="item.url"
                      class="add-quick pull-right fa fa-plus"
                      title="Add to Quick Links"
                      tabindex="0"
                      (agInteract)="addToQuickMenu(item.menuId, item.menuItem)"
                    >
                    </i>
                    <ul *ngFor="let subItem of item.subItems">
                      <li class="sub-items">
                        <a
                          tabindex="0"
                          [rel]="gMenus?.label + ' > ' + item.label + ' > ' + subItem.label"
                          [id]="'subItems_' + subItem.menuItem"
                          (agInteract)="itemClick(subItem)"
                        >
                          {{ subItem.label }}
                        </a>
                        <i
                          class="add-quick pull-right fa fa-plus"
                          title="Add to Quick Links"
                          tabindex="0"
                          (agInteract)="addToQuickMenu(subItem.menuId, subItem.menuItem)"
                        >
                        </i>
                      </li>
                    </ul>
                  </li>
                </ul>
              </mat-card-content>
            </mat-card>
          </div>
        </ngx-masonry>
      </div>
    </div>
  </div>
</main>
